import { gate } from 'hub-http/gates';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BreezeLoadingDot } from 'ai-components-ui-library/components/loading/BreezeLoadingDot';
import { useIsUngated } from 'ai-components-ui-library/hooks/useIsUngated';
import ErrorSectionFormatter from '../../conversational/internal/ErrorSectionFormatter';
import SimpleMessageSection from '../../conversational/SimpleMessageSection';
import { copilotV2MessageToMessageWithSections } from './utils/copilotMessageMapUtils';
import { useContext } from 'react';
import { CopilotPreviewContext } from '../context/CopilotPreviewContextProvider';
import { isSimplifiedPreviewResult, isV2PreviewMessage } from './utils/previewMigrationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CopilotPreviewDataSection = ({
  usageTracker,
  messages,
  onQuickActionClick
}) => {
  // get preview data from reactive var
  const {
    previewData
  } = useContext(CopilotPreviewContext);
  const {
    text,
    isStreamingComplete,
    errorCode
  } = previewData;
  const isUngatedForSimplifiedPreviews = useIsUngated(gate('CopilotPreviewsV2:Simplified'));

  // when streaming
  if (!isStreamingComplete && messages.length === 0) {
    return /*#__PURE__*/_jsxs(Text, {
      as: "span",
      display: "inline-block",
      whiteSpace: "pre-wrap",
      children: [text, /*#__PURE__*/_jsx(Text, {
        as: "span",
        display: "inline-block",
        children: /*#__PURE__*/_jsx(BreezeLoadingDot, {})
      })]
    });
  }

  // when error
  if (errorCode) {
    return /*#__PURE__*/_jsx(ErrorSectionFormatter, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiAddonCopilotPreview.components.copilotV2.ablyError"
      })
    });
  }

  // Handle SimplifiedPreviewResult messages
  if (messages.length > 0 && isSimplifiedPreviewResult(messages[0]) && isUngatedForSimplifiedPreviews) {
    const simplifiedMessages = messages;
    return /*#__PURE__*/_jsx(_Fragment, {
      children: simplifiedMessages.map((preview, index) => {
        // Generate a unique key using index and createdAt
        const key = `simplified-${index}-${preview.createdAt}`;
        return /*#__PURE__*/_jsx(SimpleMessageSection, {
          section: preview.llmResponse[0],
          usageTracker: usageTracker
        }, key);
      })
    });
  }

  // Previews v2 message
  return messages === null || messages === void 0 ? void 0 : messages.map(message => {
    const mapToV1Message = isV2PreviewMessage(message) && copilotV2MessageToMessageWithSections(message);
    if (!mapToV1Message) {
      return null;
    }
    return mapToV1Message.sections.map(section => /*#__PURE__*/_jsx(SimpleMessageSection, {
      section: section,
      onQuickActionClick: onQuickActionClick,
      usageTracker: usageTracker
    }, section.id));
  });
};